module.exports = __webpack_public_path__ + "static/media/mt.6ae60086.svg";